module.exports = __webpack_public_path__ + "static/media/autism-spectrum-disorder-treatment.dd2cfc31.png";